export enum DisplayStatus {
    REQUEST_SUBMITTED = "REQUEST_SUBMITTED",
    PENDING = "PENDING",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
    ACTIVE = "ACTIVE",
    RELEASED = "RELEASED",
    CANCELLED = "CANCELLED",
    ERROR = "ERROR",
}